import React from 'react'
import Header from '../../../Components/Header'

function Sequencing({ heading_size = 2 }) {
    return (
        <>
            <Header text={"Sequencing"} level={heading_size}/>
            <div>
                Data
            </div>
        </>
    )
}

export default Sequencing